import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";

import type { Section } from "../types/template";
import { DraggableItem } from "./DraggableItem";

type SelectedModulesPanelProps = {
  selectedSections: Section[];
  totalAvailable: number;
  draggedIndex: number | null;
  dragOverIndex: number | null;
  onRemove: (sectionId: string) => void;
  onDragStart: (e: React.DragEvent, index: number) => void;
  onDragEnd: () => void;
  onDragOver: (e: React.DragEvent, index: number) => void;
  onDrop: (e: React.DragEvent, index: number) => void;
};

export const SelectedModulesPanel = ({
  selectedSections,
  totalAvailable,
  draggedIndex,
  dragOverIndex,
  onRemove,
  onDragStart,
  onDragEnd,
  onDragOver,
  onDrop,
}: SelectedModulesPanelProps) => {
  return (
    <Card className="p-4 pb-0">
      <div className="flex items-center justify-between gap-2">
        <h3 className="text-sm font-medium">Selected Modules (Drag to Reorder):</h3>
        <Badge>
          {selectedSections.length}/{totalAvailable} Added
        </Badge>
      </div>

      <div className="max-h-96 space-y-2 overflow-y-auto pb-2">
        {selectedSections.length === 0 ? (
          <>
            {Array.from({ length: 5 }).map((_, index) => (
              <div key={index} className="h-12 rounded-lg bg-gray-100" />
            ))}
          </>
        ) : (
          selectedSections.map((section, index) => (
            <DraggableItem
              key={section.id}
              section={section}
              index={index}
              onRemove={onRemove}
              onDragStart={onDragStart}
              onDragEnd={onDragEnd}
              onDragOver={onDragOver}
              onDrop={onDrop}
              isDragging={draggedIndex === index}
              isOver={dragOverIndex === index && draggedIndex !== index}
            />
          ))
        )}
      </div>
    </Card>
  );
};
